import React, { useState } from 'react';
import WorkCard from '../Components/WorkCard/WorkCard.jsx';
import { projects } from "../data/projects.js";
import './style-sheet.css';

export const Portefølje = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', 'JAVA', 'C#', 'Websites', 'Mobile Apps'];

  const filteredProjects = selectedCategory === 'All'  ? projects : projects.filter(project => project.category === selectedCategory);

  return (
    <main className="grid">
      <div className="div-UdvalgtArbejde blue-border1">
        <h2 className="h2-blue">Udvalgt Arbejde</h2>
        <div className="category">
          {categories.map(category => (
            <a key={category} className="button-link">
              <button
                className={selectedCategory === category ? 'active' : ''}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            </a>
          ))}
        </div>
        <div className="work-grid">
          {filteredProjects.length > 0 ? (
            filteredProjects.map(p => (
              <WorkCard key={p.id} {...p} />
            ))
          ) : (
            <p>Ingen projekter fundet i kategorien {selectedCategory}.</p>
          )}
        </div>
      </div>
    </main>
  );
};